import { useEffect, useState } from 'react';
import './Form.scss';
import cn from 'classnames';

const FORM_URL =
  'https://script.google.com/macros/s/AKfycbxSduK51wL_2H3bv0xNmzFE48IoqOt5oTiqOtCgILb_jQ0pbuCFfEUcnh22eZV2oVIz/exec';

const token = '2XjFwIxoa4t7jql0bd7wo91bd0';

const Form = ({ onClose, type = 'Looking to hire talent' }) => {
  const [isSuccess, setSuccess] = useState(false);
  const [selectedType, setSelectedType] = useState(type);
  const [isSending, setSending] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [messageText, setMessageText] = useState('');

  useEffect(() => {
    window.addEventListener('keydown', handlePress);
    document.body.classList.add('no-scroll');

    return () => {
      window.removeEventListener('keydown', handlePress);
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const handleClose = () => {
    onClose();
    setSuccess(false);
  };

  const handlePress = e => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  const validateEmail = value => {
    return String(value)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const isDisabled = isSending || !name.trim() || !email.trim() || !validateEmail(email);

  const handleSend = async e => {
    e.preventDefault();
    setSending(true);

    try {
      const values = {
        token,
        full_name: name,
        email,
        phone,
        company,
        type,
        message: messageText,
      };

      await fetch(`${FORM_URL}`, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });

      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={cn('popup', isSuccess && 'popup-success')}>
      {isSuccess ? (
        <div className='success'>
          <span className='success-text'>Thank you. We'll get back to you soon.</span>
        </div>
      ) : (
        <div className='form'>
          <span className='form-close' onClick={handleClose}>
            <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
              <path d='M0.707031 0.707108L10.707 10.7071' stroke='#425A57' stroke-width='2' />
              <path d='M10.707 0.707108L0.707031 10.7071' stroke='#425A57' stroke-width='2' />
            </svg>
          </span>

          <span className='form-title'>Let's talk</span>
          <span className='form-text'>
            Whether you're looking for talent or exploring the future of your agency, we'd love to hear from you.
          </span>

          <form className='form-content' onSubmit={handleSend}>
            <div className='form-type-holder'>
              <span
                className={cn('form-type', selectedType === 'Looking to hire talent' && 'form-type-active')}
                onClick={() => setSelectedType('Looking to hire talent')}
              >
                Looking to hire talent
              </span>

              <span
                className={cn('form-type', selectedType === 'I own a staffing agency' && 'form-type-active')}
                onClick={() => setSelectedType('I own a staffing agency')}
              >
                I own a staffing agency
              </span>
            </div>

            <div className='form-row'>
              <label className='form-label'>
                Full Name *
                <input className='form-input' value={name} onChange={e => setName(e.target.value)} />
              </label>

              <label className='form-label'>
                Email *
                <input className='form-input' type='email' value={email} onChange={e => setEmail(e.target.value)} />
              </label>
            </div>

            <div className='form-row'>
              <label className='form-label'>
                Company / Agency
                <input className='form-input' value={company} onChange={e => setCompany(e.target.value)} />
              </label>

              <label className='form-label'>
                Phone number
                <input className='form-input' value={phone} onChange={e => setPhone(e.target.value)} />
              </label>
            </div>

            <label className='form-label'>
              How can we help?
              <textarea className='form-input form-textarea' value={messageText} onChange={e => setMessageText(e.target.value)} />
            </label>

            <button type='submit' disabled={isDisabled} className={cn('form-button', isDisabled && 'form-button-disabled')}>
              {isSending ? 'Sending...' : 'Send inquiry'}
            </button>

            <span className='form-tip'>All conversations are completely confidential. We'll respond within 24 hours.</span>
          </form>
        </div>
      )}
    </div>
  );
};

export default Form;
